import { ActionEnum } from '@libs/types/src/authorization/enum/action.enum';
import { Operations } from '@libs/types/src/authorization/enum/operation.enum';
import { getWorkTypeResources } from '@libs/types/src/authorization/work-type-resources';
import { featureOn } from '../feature-flag';
import type { GlobalStore } from '../store/global.global-store';

export function healthcareCalendarOperation(action: ActionEnum): Operations {
    // Keep legacy permissions usable while the old healthcare path can still be selected.
    return `${featureOn.HEALTHCARE_CALENDAR_MIGRATION ? 'calendar' : 'workScheduler'}.${action}` as Operations;
}

export function canCreateHealthcarePlannedWork(
    store: Pick<GlobalStore, 'isAllowed' | 'isAllowedForService'>,
    workType: string,
    serviceId: number | null | undefined,
): boolean {
    if (!featureOn.HEALTHCARE_CALENDAR_MIGRATION) return store.isAllowed('plannedWork.create')();
    return !!serviceId && getWorkTypeResources(workType)
        .some(resource => store.isAllowedForService(`${resource}.create`, serviceId)());
}
